import { render, staticRenderFns } from "./partner-site.vue?vue&type=template&id=253c9322&scoped=true&"
import script from "./partner-site.vue?vue&type=script&lang=js&"
export * from "./partner-site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c9322",
  null
  
)

export default component.exports